import InsightCard from "./InsightCard";

export default function InsightPanel({ insights = [] }) {

  if (!insights.length) {
    return (
      <div className="text-center text-gray-600 text-sm py-6 border border-dashed border-gray-800 rounded-xl">
        No notable insights detected yet.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-3">
      {insights.map((insight, i) => (
        <InsightCard key={i} {...insight} />
      ))}
    </div>
  );
}
